module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_5012.0c6180fb.png";